import TabletBanner from "../../../molecules/layouts/app/TabletBanner";
import Header from "../../../molecules/layouts/navbar/Header";

const TabletLayout = ({ children }) => {
  return (
    <div className="flex flex-col bg-gray-100 min-h-screen">
      <Header />
      <div className="relative flex-1 flex justify-center">
        <div className="absolute inset-0">
          <TabletBanner />
        </div>
        <div className="relative bg-white rounded-lg w-3/4 p-6 min-h-[50vh] my-32 shadow-lg">
          <div className="flex justify-center">
            <div className="w-full max-w-md">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabletLayout;
